

$(function () {
    $(".chart-total").each(function (idx, element) {
        var dataUrl = $(element).data("url");
        var value = parseInt($(element).data("value"));
        var maxValue = parseInt($(element).data("max-value"));

        var _render = function () {

            //input
            var maxDimens = parseInt($(element).data("max-dimens"));
            var color = $(element).data("progress-color");
            var padding = parseInt($(element).data("padding"));
            var width = parseInt($(element).data("track-width"));
            var countFontRatio = parseFloat($(element).data("count-font-ratio"));


            //internal
            var dimens = 0;
            var startingPoint = -0.5;
            var pointValue = startingPoint;
            var currentPoint = startingPoint;
            var timer;
            var _ctx;

            var $canvas = $(element).find("canvas");
            var canvas = $canvas.get(0);
            var pw = $(element).parent().width();

            pointValue = (value / (maxValue / 20) * 0.1) - 0.5;

            if (maxDimens > 0) {
                dimens = Math.min(pw, maxDimens);
                $canvas.parent().css("max-width", dimens.toString() + "px");
            }
            else
                dimens = pw;

            canvas.height = dimens;
            canvas.width = dimens;

            if (!countFontRatio)
                $canvas.parent().find(".legend-val").css("font-size", dimens / value.toString().length);
            else
                $canvas.parent().find(".legend-val").css("font-size", dimens * countFontRatio);

            _ctx = canvas.getContext("2d");

            //set elements
            $canvas.parent().find(".legend-val").val(value);


            var _draw = function () {

                _ctx.clearRect(0, 0, dimens, dimens);
                _ctx.beginPath();
                _ctx.arc(dimens / 2, dimens / 2, (dimens / 2) - padding, startingPoint * Math.PI, 1.5 * Math.PI);
                _ctx.strokeStyle = "#ccc";
                _ctx.lineWidth = 2;
                _ctx.lineCap = "square";
                _ctx.stroke();

                if ( maxValue > 0) {

                    if (currentPoint > startingPoint) {
                        _ctx.beginPath();
                        _ctx.arc(dimens / 2, dimens / 2, (dimens / 2) - padding, startingPoint * Math.PI, currentPoint * Math.PI);
                        _ctx.strokeStyle = color;
                        _ctx.lineWidth = width;
                        _ctx.lineCap = "round";
                        _ctx.stroke();
                    }
                    else if (currentPoint == startingPoint && currentPoint < pointValue) {
                        _ctx.beginPath();
                        _ctx.arc(dimens / 2, dimens / 2, (dimens / 2) - padding, startingPoint * Math.PI, currentPoint * Math.PI);
                        _ctx.strokeStyle = color;
                        _ctx.lineWidth = width;
                        _ctx.lineCap = "round";
                        _ctx.stroke();
                    }
                }

                currentPoint += 0.1;

                if (currentPoint > pointValue) {
                    clearInterval(timer)
                }

            };

            timer = setInterval(_draw, 100);
        };

        var _fetchData = function () {
            if (!dataUrl) return;

            $.ajax({
                url: dataUrl,
                method: "GET",
                success: function (d) {
                    value = d.Value || d.value || 0;
                    maxValue = d.MaxValue || d.maxValue || 0;

                    _render();
                },
                error: function (x, s, e) {
                    //if aborting...
                    if (x.status === 0 && x.readyState === 0) return;

                    _showError("An error has ocurred. Please try again later");
                }
            });
        };

        if (dataUrl) {
            value = 0;
            maxValue = 100;

            _render();
            _fetchData();
        }
        else {
            _render();
        }

        $(window).resize(function () {
            _render();
        });

    });
})